





























import { defineComponent, PropType, computed, ref } from '@vue/composition-api'
import { GetMyInsurancePoliciesRes } from '@/api/api-type'
import { hideLoading, showLoading, showToast } from '@/common/ts/toast'
import { getCompanyUrl, getElectronicsBill } from '@/api'
import { hideCornerButtonMore } from '@/common/biz/corner-button'
import { bizdate } from '@didi/utils'
import { omega } from '@didi/driver-biz-sdk'
import { SHORT_NAME_MAP } from '@/common/biz/constants'

const statusMap = {
  4: '已保障',
  5: '已失效',
  7: '已退保',
  8: '已领取',
  9: '已理赔',
  10: '已终止'
}
export default defineComponent({
  props: {
    info: {
      // 保单单状态 保单状态 1-无投保单, 2-待承保，3-撤单, 4-有效，5-过期，6-暂停 7-退保 8-领取 9-理赔 10-终止
      type: Object as PropType<GetMyInsurancePoliciesRes[0]>,
      default: () => {
        return {}
      }
    }
  },
  setup(props) {
    const effectTime = computed(() => {
      const info = props.info
      if (info.status !== 2) return ''
      const time = Number(info.start_time) * 1000
      return bizdate.dateFormat(time, 'yyyy/MM/dd') + '生效'
    })
    const statusName = computed(() => {
      return statusMap[props.info.status]
    })
    const protectDays = computed(() => {
      const info = props.info
      if (info.status !== 4) return -1
      return info.protect_days
    })

    const applyBtnAbled = computed(() => {
      const info = props.info
      if (info.status === 4 || info.status === 8 || info.status === 9) return true
    })

    const policyType = computed(() => {
      const info = props.info
      const productDetail = JSON.parse(info.product_detail)
      if (typeof productDetail === 'object') {
        return productDetail[0].policyType
      }
      return -1
    })

    // 待生效-查询按钮
    // 已生效-查询按钮+申请理赔按钮
    // 退保-查询按钮
    // 失效-查询+查看理赔

    let requesting = false
    function apply(needOmega = true) {
      const info = props.info
      if (requesting) return
      if (info.company_id === 20004) {
        watch()
        return
      }
      needOmega && omega.trackEvent('am_c_insure_medical_mypolicy_claim_ck', {
        policy_type: policyType.value,
        company_id: info.company_id
      })
      requesting = true
      showLoading()
      getCompanyUrl({
        jump_type: 2,
        company_id: info.company_id,
        policy_id: info.policy_id,
        item_id: info.item_id
      }).then(res => {
        hideLoading()
        hideCornerButtonMore()
        window.location.href = res as unknown as string
      }).catch(() => {
        showToast('请稍后再试')
      }).finally(() => {
        requesting = false
      })
    }

    function watch() {
      const info = props.info
      omega.trackEvent('am_c_insure_medical_mypolicy_check_ck', {
        policy_type: policyType.value,
        company_id: info.company_id
      })
      // 太保 申请理赔、查询保单在同一个页面
      if (info.company_id === 20002) {
        apply(false)
        return
      }
      getElectronicsBill({
        policy_id: info.policy_id,
        is_self: 1
      }).then(res => {
        res.electronic_bill_address && (window.location.href = res.electronic_bill_address)
      })
    }

    const familyMap = ref<Record<GetMyInsurancePoliciesRes[0]['insurant_type'], string>>({
      1: '本人',
      2: '配偶',
      3: '子女'
    })
    return {
      applyBtnAbled,
      effectTime,
      statusName,
      protectDays,
      familyMap,
      watch,
      apply,
      nameMap: SHORT_NAME_MAP
    }
  }
})

